import * as React from "react";
const Ticket = (props: any) => (
    <svg
        width={26}
        height={24}
        viewBox="0 0 26 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m3.19 6.517 7.683-5.379a1.9 1.9 0 0 1 2.643.466l1.212 1.73q.027.038.05.078zm-2.6 6.238-.525-1.961a1.9 1.9 0 0 1 1.343-2.325L20.662 3.31a1.9 1.9 0 0 1 2.325 1.342l.547 2.04a1.52 1.52 0 0 1-.532 1.59 2.374 2.374 0 0 0 1.154 4.226 1.46 1.46 0 0 1 1.223 1.07l.556 2.077a1.9 1.9 0 0 1-1.342 2.326L5.338 23.14a1.9 1.9 0 0 1-2.325-1.343l-.524-1.954a1.65 1.65 0 0 1 .55-1.709 2.374 2.374 0 0 0-1.124-4.182A1.64 1.64 0 0 1 .59 12.756M17.43 9.58a1.424 1.424 0 1 0-.702-2.76 1.424 1.424 0 0 0 .701 2.76m.982 3.668a1.425 1.425 0 0 0-.737-2.75 1.424 1.424 0 0 0 .737 2.75m.983 3.667a1.422 1.422 0 0 0 .356-2.62 1.423 1.423 0 1 0-.356 2.62"
            fill="currentColor"
        />
    </svg>
);
export default Ticket;
